import { useMemo } from 'react';
import { Settings } from 'lucide-react';
import { useActiveOrgSlug } from '@/lib/useOrgRoutes';
import type { NavItem } from '../NavBar/nav-types';
import { useNavSources } from '../NavBar/useNavSources';
import { buildConfigureNav } from './configure-nav';
import { resolveConfigureEntry } from './configure-return';

/**
 * The Configure door: a gear icon whose `to` restores the last section
 * visited in the active organization (validated against the current nav).
 * Shared by SessionDock, NavBar, the account-menu gear, and MobileBottomNav.
 *
 * `tutorialId: 'nav-settings'` keeps the tutorial plugin's spotlight target
 * resolving after the Settings -> Configure rename.
 */
export function useConfigureEntry(): NavItem {
  const slug = useActiveOrgSlug();
  const { configureDrillGroups } = useNavSources();

  const groups = useMemo(
    () => buildConfigureNav(slug, configureDrillGroups),
    [slug, configureDrillGroups],
  );

  return useMemo<NavItem>(
    () => ({
      to: resolveConfigureEntry(slug, groups),
      label: 'Configure',
      icon: Settings,
      tutorialId: 'nav-settings',
    }),
    [slug, groups],
  );
}
